import { parseDocument } from "yaml";
import { normalizeText, validateTextSource } from "./data-tool-core.js";

export function formatYaml(source, { indentation = 2 } = {}) {
  const text = normalizeText(source);
  const validation = validateTextSource(text, "YAML");
  if (validation) return { error: validation, output: "" };
  try {
    const document = parseDocument(text, {
      prettyErrors: true,
      strict: true,
      uniqueKeys: true
    });
    if (document.errors.length) return { error: yamlError(document.errors[0]), output: "" };
    const output = document.toString({
      indent: Number(indentation) === 4 ? 4 : 2,
      lineWidth: 0
    }).trimEnd();
    return {
      error: "",
      output,
      lines: output ? output.split("\n").length : 0
    };
  } catch (error) {
    return { error: yamlError(error), output: "" };
  }
}

export function validateYaml(source) {
  const result = formatYaml(source);
  return result.error ? result : { ...result, output: normalizeText(source) };
}

function yamlError(error) {
  const position = error?.linePos?.[0];
  if (position) return `Invalid YAML near line ${position.line}, column ${position.col}.`;
  return "Invalid YAML. Check indentation, mapping keys, sequences, and quoted values.";
}
